

const illustrationHeight = () => {
    const illustration = document.querySelector('.header--illustration');
    let illustrationHeight = 0;
    if (illustration) {
        illustrationHeight = illustration.offsetHeight;
    }

    return  illustrationHeight;
}

export default illustrationHeight;

